<script>
export default {
  props: {
    groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: 'Users',
          dataIndex: 'users',
          key: 'users',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.users - b.users,
        },
        {
          title: 'Organization',
          dataIndex: 'organization',
          key: 'organization',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.organization.localeCompare(b.organization),
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
      ],
    }
  },
  methods: {
    onDelete(record) {
      this.$emit('deleteGroup', record)
    },
    selectRow(record) {
      const groupId = record.pk.replace('GROUP#', '')
      this.$router.push({
        name: 'group-profile',
        params: { groupId },
      })
    },
  },
}
</script>

<template>
  <a-table :data-source="groups" :columns="columns">
    <template slot="customRender" slot-scope="text, record, index, column">
      <template>
        <div v-if="column.key === 'name'">
          <a-tag
            :color="record.color"
            style="cursor: pointer"
            @click="() => selectRow(record, column)"
            >{{ text }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'users'">{{ text }}</div>
        <div v-else-if="column.key === 'actions'">
          <ul class="actions">
            <li>
              <a
                href="javascript:;"
                title="Edit Group"
                @click="() => selectRow(record, column)"
                ><a-button type="primary" icon="edit" size="small"></a-button
              ></a>
            </li>
            <li>
              <a-popconfirm
                title="Sure to delete?"
                @confirm="() => onDelete(record)"
              >
                <a href="javascript:;" title="Delete Group"
                  ><a-button type="danger" icon="delete" size="small"></a-button
                ></a>
              </a-popconfirm>
            </li>
          </ul>
        </div>
        <div v-else>{{ text }}</div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}
</style>
